import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  apply(event) {
    const filterKey = event.target.name;
    const filterValue = event.target.value;
    const filterType = event.target.type;

    // Dispatch custom event with filter data
    this.element.dispatchEvent(
      new CustomEvent('filter:apply', {
        bubbles: true, // Ensure it bubbles up to the entries controller
        detail: {
          key: filterKey,
          value: filterValue,
          type: filterType,
        },
      })
    );
  }
}
